export const getCityById = (cityId, cities) => {
    const defaultReturn = {
        id: '',
        legacyId: cityId,
    };

    if (!cities || !defaultReturn) return defaultReturn;

    const found = Object.values(cities).find(city => (
        city.id === String(cityId) || String(city.legacyId) === String(cityId)
    ));

    return (found || defaultReturn);
};
